import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fileDirectories } from '../../../utils/view-settings';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { UserService } from '../../services/user.service';

import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { listFeedList } from '../../../utils/constants';
import { ICONS } from '../../../utils/svg-icons';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';
@Component({
  selector: 'app-likes-list',
  imports: [CommonModule, InfiniteScrollModule, SafeHtmlPipe],
  templateUrl: './likes-list.component.html',
  styleUrl: './likes-list.component.scss',
  providers: [NgbActiveModal], // ✅ Add provider here
})
export class LikesListComponent {
  likesList: any = [];

  fileDirectoriesPath: any = fileDirectories.profile;

  @Input() postId: any;
  userDetail: any;
  LikeCounts: any;
  nextToken: any = null;
  activeModal = inject(NgbActiveModal); // ✅ Use inject() for Standalone Components
  ICONS = ICONS;
  constructor(
    private _userService: UserService,
    private _commonDataService: CommonDataSharingService,
    public activeOffcanvas: NgbActiveOffcanvas,
  ) {}
  ngAfterViewInit() {
    this._userService.user.subscribe((user: any) => {
      this.userDetail = user ?? null;
    });
    this.likeFeedList();
    this.postCount();
  }
  likeFeedList() {
    const mutation = `query MyQuery {
      getLikes(limit: 20, postId: \"${this.postId}\",nextToken:${this.nextToken}) {
        ${listFeedList}
        }
      }`;
    this._commonDataService.graphqlApiCall(mutation).then((res) => {
      this.nextToken = res.data?.getLikes?.nextToken ? JSON.stringify(res.data?.getLikes?.nextToken) : null;
      this.likesList = res?.data?.getLikes?.items;
    });
  }
  onClose() {
    this.activeOffcanvas.close();
  }
  postCount() {
    let array: any = [this.postId];
    const mutation = `query getPostsCounts {
        getPostsCounts(postIds: ${JSON.stringify(array)}) {
            items {
            commentCount
            likeCount
            postId
          }
        }
      }`;
    this._commonDataService.graphqlApiCall(mutation).then((res) => {
      this.LikeCounts = res?.data?.getPostsCounts?.items[0]?.likeCount;
    });
  }
}
